<div class="breadcrumb-container">
    <div class="row">
        <div class="col-lg-12">
            <h1>Code Management</h1>
            <ol class="breadcrumb" id="breadcrumbNav">
                <li>
                    <a [routerLink]="['/home']">
                        <i class="fa fa-home "></i>
                        <span>ProManual </span>
                    </a>
                </li>
                <li class="active">
                    <i class="fa fa-map-marker"></i>
                    <span>Code Management</span>
                </li>
            </ol>
        </div>
    </div>
</div>
<div class="component-container" style="height: 90%;">
    <div class="well" style="height: 100%;">
        <div style="overflow-x: scroll; height: 100%;">
            <div class="row" style="height: 100%; overflow: hidden;  width:165%;">
                <div style="height: 100%; padding-bottom: 10px; float: left; position: relative; min-height: 1px; padding-left: 15px; padding-right: 15px; width:20%;" *ngFor="let attribute of attributes">
                    <div class="panel panel-success" style="height: 100%">
                        <div class="panel-heading">
                            <h5 style="display: inline-block;">
                                <span class="badge">{{ attribute.Maps.Data.length }}</span>
                                {{ attribute.Name }}
                            </h5>
                            <div class="pull-right">
                                <div class="btn-group btn-group-md">
                                    <button type="button" class="btn btn-primary" title="Add Mapping" (click)="addMap(attribute)">
                                        <span data-toggle="tooltip" class="fa fa-plus-square fa-lg"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="panel-body" style="height: 100%; padding-bottom: 110px;">
                            <table class="table table-condensed table-striped" style="margin-bottom:0;">
                                <colgroup>
                                    <col style="width: 40%;" />
                                    <col style="width: 40px;" />
                                    <col style="width: auto;" />
                                    <col style="width: 80px;" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>
                                            <span>Document Name Part</span>
                                        </th>
                                        <th></th>
                                        <th>
                                            <span>Mapping</span>
                                        </th>
                                        <th></th>
                                    </tr>
                                </thead>
                            </table>
                            <div style="height: 100%; overflow-y: scroll;">
                                <table class="table table-condensed">
                                    <colgroup>
                                        <col style="width: 40%;" />
                                        <col style="width: 40px;" />
                                        <col style="width: auto;" />
                                        <col style="width: 50px;" />
                                    </colgroup>
                                    <tbody>
                                        <tr *ngFor="let map of attribute.Maps.Data">
                                            <td>
                                                {{ map.Part }}
                                            </td>
                                            <td>
                                                <i class="fa fa-lg fa-arrow-right"></i>
                                            </td>
                                            <td>
                                                {{ map.Value }}
                                            </td>
                                            <td>
                                                <i class="pm-button" title="Edit Mapping" (click)="editMap(map, attribute)">
                                                    <span data-toggle="tooltip" class="fa fa-fw fa-edit"></span>
                                                </i>
                                                <i class="pm-button" title="Delete Mapping" (click)="removeMap(map)">
                                                    <span data-toggle="tooltip" class="fa fa-fw fa-trash-o"></span>
                                                </i>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div bsModal #mapManipulate="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog">
        <div class="modal-content">
            <form (ngSubmit)="create()">
                <div class="modal-header">
                    <button type="button" class="close" aria-hidden="true" (click)="close()">&times;</button>
                    <h4 class="modal-title" id="myModalLabel" *ngIf="add">
                        Add Code &bull; {{ attribute.Name }}
                    </h4>
                    <h4 class="modal-title" id="myModalLabel" *ngIf="!add">
                        Edit Code &bull; {{ map.Part }} <i class="fa fa-arrow-right"></i> {{ map.Value }}
                    </h4>
                </div>
                <div class="modal-body" data-bind="with: entity">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group input-group has-feedback" data-bind="validationElement: Part">
                                <label class="control-group input-group-addon" for="newPart">Document Part</label>
                                <input name="newPart" type="text" class="form-control" placeholder="Document Part" [(ngModel)]="map.Part"/>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group input-group has-feedback" data-bind="validationElement: Value">
                                <label class="control-group input-group-addon" for="newValue">Mapping</label>
                                <input name="newValue" type="text" class="form-control" placeholder="Maps To" [(ngModel)]="map.Value" />
                            </div>
                        </div>
                    </div>
                    <br *ngIf="attribute.DisplayOrder == 3 && !add" />
                    <div class="row" *ngIf=" attribute.DisplayOrder == 3 && !add" >
                        <div class="col-md-9">
                            <input id="logoToUpload" name="logoToUpload" class="form-control form-control-static" placeholder="Choose File" disabled="disabled" [(ngModel)]="filename" />
                        </div>
                        <div class="col-md-2">
                            <div class="fileUpload btn btn-info">
                                <span>Choose File</span>
                                <input id="uploadLogoButton" class="upload" type="file" accept="image/*" (change)="preUpload($event)" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button *ngIf="add" type="button" class="pull-left btn btn-default" (click)="create(true)">Create and Add Another</button>
                    <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
                    <button type="submit" class="btn btn-primary">{{ add ? 'Create' : 'Save' }}</button>
                </div>
            </form>
        </div>
    </div>
</div>